import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../../common/Fieldset";
import Row from "../../../common/Row";
import TextAreaInput from "../../../common/TextAreaInput";

const ToegankelijkheidPerAfstand = props => {
	const { model } = props;

	if (!model.beschrijvingToegankelijkheid)
		return null;

	return <Fieldset title={"Toegankelijkheid per afstand"}>
		<Row>
			<TextAreaInput
				name="beschrijvingToegankelijkheid"
				label="Beschrijving toegankelijkheid"
				value={model.beschrijvingToegankelijkheid}
				onChange={() => undefined}
				disabled
				optional
				height={7}
			/>
		</Row>
	</Fieldset>;
};

ToegankelijkheidPerAfstand.propTypes = {
	model: PropTypes.object.isRequired
};

export default ToegankelijkheidPerAfstand;
